import { addToCollection } from "../addToCollection";
export var BffRequestBuilder = {
    buildEventsByEventIdForBetSlipRequest: function (items) {
        var request = {
            ids: [],
            marketIds: [],
            selectionIds: []
        };
        items.forEach(function (curr) {
            request.ids = addToCollection(request.ids, curr.eventId);
            request.marketIds = addToCollection(request.marketIds, curr.marketId);
            request.selectionIds = addToCollection(request.selectionIds, curr.selectionId);
        });
        return request;
    }
};
//# sourceMappingURL=bffRequestBuilder.js.map